import React from "react";
import CustomCheckbox from "../../common/CustomCheckbox";
import { formatCurrency, formatNumber } from "../../../lib/utils";

export default class BillingSummary extends React.PureComponent {
  render() {
    const {
      allowDonorToPayProcessingFee,
      cociCcProcessingFeePercentage,
      currencyCode,
      didDonorPayProcessingFee,
      onChangeEventOrder,
      orderTotal,
      processingFeeDonorAmount,
      ticketPriceAmount,
      ticketQuantity,
    } = this.props;

    return (
      <div className="checkout-summary">
        <div>
          <p className="fs-28 fw-600 mb-24 text-center">Review your order</p>

          {allowDonorToPayProcessingFee && (
            <CustomCheckbox
              className="mb-24 flex-justify-center"
              checked={didDonorPayProcessingFee}
              label={`Yes, I'd like to donate the cost of processing this transaction by adding ${cociCcProcessingFeePercentage}%.`}
              name="didDonorPayProcessingFee"
              onChange={onChangeEventOrder}
            />
          )}
          <div className="checkout-summary-items">
            <div className="flex flex-align-center flex-justify-space mb-16">
              <p className="fs-16">Quantity</p>
              <p>{formatNumber(ticketQuantity)}</p>
            </div>
            {allowDonorToPayProcessingFee && (
              <div className="flex flex-align-center flex-justify-space mb-16">
                <p className="fs-16">Subtotal</p>
                <p>{formatCurrency(ticketPriceAmount, currencyCode)}</p>
              </div>
            )}
            {didDonorPayProcessingFee && (
              <div className="flex flex-align-center flex-justify-space mb-16">
                <p className="fs-16">Processing fee</p>
                <p>{formatCurrency(processingFeeDonorAmount, currencyCode)}</p>
              </div>
            )}
            {allowDonorToPayProcessingFee && (
              <div className="checkout-summary-divider" />
            )}
            <div className="flex flex-align-center flex-justify-space fw-700 xxl-text mt-16">
              <p className="fs-20 fw-700">Total</p>
              <p className="fs-20 fw-700">
                {formatCurrency(orderTotal, currencyCode)}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
